<template>
    <MainContent title="Editar campaña de UPSELLING" subtitle="Modifica las reglas y condiciones de la campaña">
        <FormUpselling
            v-if="localForm"
            :initialForm="localForm"
            @terminado="$router.push({ name: 'back.upselling.index' })"
        />
    </MainContent>
</template>

<script setup>
    import { ref, onMounted } from 'vue'
    import MainContent from '@/modules/admin/ui/MainContent.vue'
    import FormUpselling from '@/modules/admin/upselling/FormUpselling.vue'
    import useCampaign from '@/composables/admin/upselling/useCampaign'

    const props = defineProps({
        campaign_id: {
            type: [String, Number],
            required: true
        }
    })

    const localForm = ref(null)
    const {
        campaignDetails,
        getCampaignDetails,
        buildInitialForm
    } = useCampaign(props.campaign_id)

    onMounted(async() => {
        await getCampaignDetails()
        localForm.value = buildInitialForm(campaignDetails.value)
    })
</script>